import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelFamiliaresView from './PanelFamiliaresView';
import * as ROUTES from '../../../../router/Routes';

const PanelFamiliaresModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelFamiliares}
      routes={[ROUTES.controlEstudios, ROUTES.familiares]}
    >
      <PanelFamiliaresView />
    </ContainerTemplate>
  );
};

export default PanelFamiliaresModule;
